import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { CAMPAIGN_STATUS, CAMPAIGN_STATUS_LABEL_BY_ID, WAITING_FOR_PRODUCTS_LABEL } from '@enums';
import { useStore } from '@hooks';
import { Tag } from '@ui';
import { Flex, Tooltip } from 'antd';
import { observer } from 'mobx-react';
import { getCampaignStatusColor } from '../../utils';

const WAITING_FOR_PRODUCTS_TOOLTIP =
    'This campaign has no available products to show. ' +
    'It will resume automatically once products are back in the campaign.';

const Status = observer(({ campaignId }) => {
    const store = useStore();
    const { getCampaign } = store.campaignsStore;
    const campaign = getCampaign(campaignId);

    const isWaitingForProducts = !campaign.pending && campaign.isWaitingForProducts;
    const color = campaign.pending
        ? getCampaignStatusColor()
        : getCampaignStatusColor(campaign.status, isWaitingForProducts);

    let label = campaign.pending
        ? CAMPAIGN_STATUS_LABEL_BY_ID[CAMPAIGN_STATUS.PENDING]
        : CAMPAIGN_STATUS_LABEL_BY_ID[campaign.status];

    if (isWaitingForProducts) {
        label = WAITING_FOR_PRODUCTS_LABEL;
    }

    const tag = (
        <Tag data-e2e={`campaign_${campaignId}-status_value`} color={color}>
            <Flex align='center' gap={8}>
                {label}
                {campaign.pending ? <LoadingOutlined /> : null}
            </Flex>
        </Tag>
    );

    if (isWaitingForProducts) {
        return <Tooltip title={WAITING_FOR_PRODUCTS_TOOLTIP}>{tag}</Tooltip>;
    }

    return tag;
});

export default Status;
